import { useEffect, useState } from "react";
import apiClient from "../api/apiClient";
import { useLanguage } from "../i18n/LanguageContext";

const NutritionGuide = () => {
  const { t } = useLanguage();
  const [pdfUrl, setPdfUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    let objectUrl = "";

    apiClient.get("/artifacts/nutrition-guide/view", { responseType: "blob" })
      .then(({ data }) => {
        if (!active) return;
        objectUrl = window.URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
        setPdfUrl(`${objectUrl}#toolbar=0&navpanes=0&statusbar=0`);
      })
      .catch((requestError) => {
        if (!active) return;
        setError(
          requestError.response?.status === 403
            ? t("Your active package no longer includes this guide.")
            : t("The guide could not be opened. Please try again."),
        );
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
      if (objectUrl) window.URL.revokeObjectURL(objectUrl);
    };
  }, [t]);

  return (
    <main className="hpa-nutrition-viewer">
      <div className="container">
        <div className="hpa-nutrition-viewer-heading">
          <span>{t("Included with your package")}</span>
          <h1>{t("Hybrid Nutrition Guide")}</h1>
          <p>{t("Read your nutrition guide securely without leaving the academy platform.")}</p>
        </div>

        {loading && <div className="hpa-feature-state"><i className="fa-solid fa-spinner fa-spin" /><p>{t("Opening nutrition guide…")}</p></div>}
        {error && <div className="hpa-feature-state hpa-feature-locked" role="alert"><i className="fa-solid fa-triangle-exclamation" /><p>{error}</p></div>}
        {pdfUrl && (
          <div className="hpa-pdf-shell" onContextMenu={(event) => event.preventDefault()}>
            <iframe className="hpa-pdf-viewer" src={pdfUrl} title={t("Hybrid Nutrition Guide")} />
          </div>
        )}
      </div>
    </main>
  );
};

export default NutritionGuide;
